function EmptyTrackingState({ orderStatus }) {
    const getMessage = () => {
        switch (orderStatus) {
            case 'SHIPPED':
                return 'Tracking information will be available soon. Please check back in a few minutes.';
            case 'PROCESSING':
                return 'Your order is being processed. Tracking will be available once shipped.';
            default:
                return 'No tracking information available at the moment.';
        }
    };

    return (
        <div className='flex pb-10'>
            <div className="flex flex-col items-center gap-4 py-8">
                <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
                    <svg 
                        className="w-6 h-6 text-gray-400" 
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" 
                        />
                    </svg>
                </div>
                
                <div className="text-center">
                    <h3 className="font-medium text-gray-600 mb-2">No tracking updates yet</h3>
                    <p className="text-sm text-gray-500 max-w-xs">{getMessage()}</p>
                </div>
            </div>
        </div>
    );
}

export default EmptyTrackingState;
